import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';

/** API response for GET general settings - single object: { id, dateFormat, timezone, weekStartDay, timeFormat } */
export interface GeneralSettingsDTO {
  id: number;
  dateFormat: number;
  timezone: number;
  weekStartDay: number;
  timeFormat: number;
  applicationName?: string;
}

/** Payload for PUT general settings (all numeric IDs) */
export interface GeneralSettingsUpdateDTO {
  id: number;
  dateFormat: number;
  timezone: number;
  weekStartDay: number;
  timeFormat: number;
  applicationName?: string;
} 

@Injectable({
  providedIn: 'root',
})
export class GeneralSettingsService {
  private baseUrl = environment.baseUrl + '/identity/api/Setting'; 
  constructor(private _http: HttpClient) {}

  getGeneralSettings(): Observable<GeneralSettingsDTO> {
    return this._http.get<GeneralSettingsDTO>(this.baseUrl).pipe(
      map((res: any) => res?.data ?? res)
    );
  }

  updateGeneralSettings(payload: GeneralSettingsUpdateDTO): Observable<any> {
    return this._http.put(this.baseUrl, payload).pipe(
      map((res: any) => res)
    );
  }
}
